import { Auth0Client } from '@auth0/auth0-spa-js'

import {
  AUTH0_SCOPE,
  AUTH0_ISSUER_BASE_BUILDER,
  AUTH0_CLIENT_ID,
} from '@flecto/auth/src/auth.config'
import { queryClient } from '@flecto/core'
import { useQueryGetUserLogged, useMutationUpdateUserIdentity, useMutationSyncUserIdentities } from '@flecto/core/shared'
import { useTranslation } from '@flecto/translations'
import { useNotifications } from '@flecto/ui'

export function useLinkAccount() {
  const { data } = useQueryGetUserLogged()
  const { showNotification } = useNotifications()
  const { t } = useTranslation('saas', {
    keyPrefix: 'profile',
  })

  const { mutate: syncAuth0, isLoading: isSyncLoading } =
    useMutationSyncUserIdentities()

  const { mutateAsync: update } = useMutationUpdateUserIdentity()

  const authenticateUser = async () => {
    const a0 = new Auth0Client({
      cacheLocation: 'memory',
      domain: AUTH0_ISSUER_BASE_BUILDER,
      clientId: AUTH0_CLIENT_ID,
      useRefreshTokens: false,
    })
    await a0.getTokenWithPopup({
      authorizationParams: {
        scope: AUTH0_SCOPE,
        max_age: 0,
        prompt: 'consent',
        access_type: 'offline',
      },
    })
    return await a0.getIdTokenClaims()
  }

  const linkAccount = async () => {
    try {
      const response = await authenticateUser()
      const auth0_id = data?.auth0_id

      if (!auth0_id || !response?.__raw) return

      await update({
        auth0_id,
        identity: {
          link_with: response.__raw,
        },
      })

      syncAuth0()
      queryClient.invalidateQueries(['QueryGetAllIdentities'])
    } catch {
      showNotification({
        type: 'error',
        message: t('error_linking_account'),
      })
    }
  }

  return {
    linkAccount,
    isSyncLoading,
    syncAccounts: syncAuth0,
    authenticateUser,
  }
}
